import type { ReactNode } from "react";
import { Logo } from "./Logo";

/** The frame for every pre-app screen: login wall, loading, access problems. */
export function Centered({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center gap-6 px-4 py-10">
      <Logo size="text-3xl" />
      <div className="rounded-xl border border-line bg-card p-6">
        <h1 className="text-xl font-semibold">{title}</h1>
        <div className="mt-3 flex flex-col gap-4 text-muted">{children}</div>
      </div>
    </main>
  );
}

export function PrimaryButton(props: { onClick: () => void; children: ReactNode; disabled?: boolean; type?: "button" | "submit" }) {
  return (
    <button
      type={props.type ?? "button"}
      onClick={props.onClick}
      disabled={props.disabled}
      className="touch-target inline-flex items-center justify-center rounded-lg bg-brand px-5 py-2.5 font-medium text-on-brand disabled:opacity-50"
    >
      {props.children}
    </button>
  );
}

export function SecondaryButton(props: { onClick: () => void; children: ReactNode; disabled?: boolean }) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      disabled={props.disabled}
      className="touch-target inline-flex items-center justify-center rounded-lg border border-line px-4 py-2 font-medium text-ink disabled:opacity-50"
    >
      {props.children}
    </button>
  );
}
